var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal-content-mobileFull bg-grey3 radius-18",
        class: { "no-overflow": _vm.comoVerification.show },
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-top bg-grey3 flex-between-center radius-18 radius-bottom-0 p-20 top-0 pos-sticky zindex-2",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "modal-top--title flex-start-center fsize-18 color-grey1 radius-18 radius-bottom-0",
              },
              [
                !_vm.CheckoutService.isRestoMode(_vm.order)
                  ? _c(
                      "div",
                      {
                        staticClass: "mr-10 cursor-pointer hover-opacity",
                        on: {
                          click: function ($event) {
                            return _vm.$emit("go", -1)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fie-icon_arrow2-l" })]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-bold text-uppercase fsize-18 color-grey1" },
              [_vm._v("Votre commande")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close rounded-btn display-1 p-10 bg-grey3",
                attrs: { type: "button", "aria-label": "Close" },
                on: {
                  click: function ($event) {
                    return _vm.modal.dismiss()
                  },
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "font-lato text-light",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_vm._v("×")]
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "modal-main bg-grey3 px-20 pb-20 pos-relative zindex-0",
          },
          [
            _c(
              "div",
              { staticClass: "p-20 mob-p-15 bg-grey5 radius-5" },
              [
                _c("ask-info2", {
                  ref: "askInfo2",
                  attrs: { order: _vm.order },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "order-details--cart collapseBlock shadow-2 p-20 mob-p-15 bg-white mt-20 radius-5",
              },
              [
                _c(
                  "div",
                  { staticClass: "order-cart minicart" },
                  [_c("order-items", { attrs: { order: _vm.order } })],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _vm.order.shop.info.cutlery
              ? _c(
                  "div",
                  {
                    staticClass:
                      "shadow-2 p-20 mob-p-15 bg-white mt-20 radius-5",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass:
                          "switch withTxt on-off-grey withLabelFullWith mb-0",
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order.info2.cutlery,
                              expression: "order.info2.cutlery",
                            },
                          ],
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.order.info2.cutlery)
                              ? _vm._i(_vm.order.info2.cutlery, null) > -1
                              : _vm.order.info2.cutlery,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.order.info2.cutlery,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.order.info2,
                                      "cutlery",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.order.info2,
                                      "cutlery",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.order.info2, "cutlery", $$c)
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "slider round flex-shrink-0" },
                          [
                            _c(
                              "small",
                              {
                                staticClass:
                                  "flex-center-center h-100 text-bold",
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.order.info2.cutlery ? "oui" : "non"
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("checkout-promo", { attrs: { order: _vm.order } }),
            _vm._v(" "),
            _vm.CheckoutService.canConfirmByFidelite(_vm.order) &&
            _vm.hasFidCard()
              ? _c(
                  "div",
                  {
                    staticClass:
                      "shadow-2 p-20 mob-p-15 bg-white radius-5 mt-20",
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("checkout-fidcards", {
                      attrs: { order: _vm.order },
                      on: { "has-fidCard": _vm.hasFidCard },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.CheckoutService.canConfirmByComo(_vm.order)
              ? _c(
                  "div",
                  {
                    staticClass:
                      "shadow-2 p-20 mob-p-15 bg-white radius-5 mt-20",
                  },
                  [
                    _c("div", { staticClass: "flex-start-center mb-20" }, [
                      _c("i", {
                        staticClass:
                          "fsize-26 mob-fsize-22 fie-icon_offer mr-10",
                      }),
                      _vm._v(" "),
                      _vm.order.client && _vm.order.client.comoMembership
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "color-grey1 text-uppercase text-bold fsize-16 mob-fsize-14",
                            },
                            [_vm._v("Utiliser vos points fidélité ?")]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "color-grey1 text-uppercase text-bold fsize-16 mob-fsize-14",
                            },
                            [_vm._v("Programme de fidélité")]
                          ),
                    ]),
                    _vm._v(" "),
                    _c("checkout-como-points", {
                      attrs: { order: _vm.order },
                      on: { "pay-como": _vm.payComo },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.order.shop.info.salon.active
              ? _c(
                  "div",
                  { staticClass: "shadow-2 p-20 mob-p-15 bg-white radius-5" },
                  [_c("checkout-discount", { attrs: { order: _vm.order } })],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "modal-bottom bg-white w-100 pos-sticky bottom-0 zindex-1 radius-18 shadow-4",
          },
          [
            _c("total", { attrs: { order: _vm.order } }),
            _vm._v(" "),
            _c("Msg", { ref: "msg", attrs: { processing: _vm.processing } }, [
              _c("div", [_vm._v("Etat commande:")]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-center-center flex-wrap w-100 p-10" },
              [
                _vm.CheckoutService.isOrderConfirmed(_vm.order)
                  ? _c("div", { staticClass: "w-100 mx-10" }, [
                      _c(
                        "button",
                        {
                          staticClass: "eatbtn eatbtn-blue",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("go")
                            },
                          },
                        },
                        [
                          _vm._v("\n\t\t\t\t\t\tTerminé\n\t\t\t\t\t\t"),
                          _c("i", {
                            staticClass: "icone icone-uniE669",
                            staticStyle: { "vertical-align": "middle" },
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.CheckoutService.isOrderConfirmed(_vm.order)
                  ? _c(
                      "div",
                      { staticClass: "flex-1 my-10 mx-10 fsize-18 shadow-1" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btnFlat-color2 w-100",
                            on: {
                              click: function ($event) {
                                return _vm.doFinalConfirm()
                              },
                            },
                          },
                          [
                            !_vm.remainToPay()
                              ? _c("span", [_vm._v("Finaliser la commande")])
                              : _c("span", [_vm._v("Passer la commande")]),
                            _vm._v(" "),
                            _c("i", { staticClass: "fie-icon_arrow2-r" }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _vm.CheckoutService.cannotConfirm(_vm.order)
              ? _c("p", { staticClass: "text-danger" }, [
                  _vm._v("La confirmation de commande est\n\t\t\t\tdésactivée"),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("checkout-client-login", {
                  staticStyle: { display: "inline-block" },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "fullPopover pos-absolute top-0 h-100 w-100 ease-2",
        class: {
          "zindex-4 opacity-1": _vm.comoVerification.show,
          "zindex--1 opacity-0": !_vm.comoVerification.show,
        },
      },
      [
        _c("div", {
          staticClass:
            "fullPopover--backdrop h-100 w-100 pos-relative zindex-0",
          on: {
            click: function ($event) {
              _vm.comoVerification.show = false
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "fullPopover--content pos-absolute w-100 bg-white zindex-1",
            class: { "bottom-0": _vm.comoVerification.show },
          },
          [
            _c("div", [_vm._v("Code de vérification Wallet")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "pull-right min-mb-40 pos-relative zindex-1" },
              [
                _c(
                  "button",
                  {
                    staticClass: "close radius-circle display-1 bg-white m-10",
                    attrs: { type: "button", "aria-label": "Close" },
                    on: {
                      click: function ($event) {
                        _vm.comoVerification.show = false
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "font-lato text-light",
                        attrs: { "aria-hidden": "true" },
                      },
                      [_vm._v("×")]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "klear p-20" }, [
              _c("form", [
                _c(
                  "div",
                  {
                    staticClass: "has-float-label lineInput mt-20",
                    class: { invalid: _vm.comoVerification.error },
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.comoVerification.code,
                          expression: "comoVerification.code",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { type: "tel", id: "ask-code", placeholder: " " },
                      domProps: { value: _vm.comoVerification.code },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.comoVerification,
                            "code",
                            $event.target.value
                          )
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "ask-code" } }, [
                      _vm._v("Code de vérification"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.comoVerification.error,
                        expression: "comoVerification.error",
                      },
                    ],
                    staticClass: "color-bo-danger mt-5",
                  },
                  [_vm._v(_vm._s(_vm.comoVerification.error))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mt-30" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btnFlat-color2 w-100 flex-1 fsize-18 shadow-1",
                      on: {
                        click: function ($event) {
                          return _vm.confirmOrderWithComoVerification(
                            _vm.comoVerification.code
                          )
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "fie-icon_ticket" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Confirmer la commande")]),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass:
          "labelText flex-start-center pr-10 fsize-16 mob-fsize-14 color-grey1 text-uppercase text-bold",
      },
      [
        _c("i", {
          staticClass: "fie-icon_on-site fsize-26 mob-fsize-22 mr-10",
        }),
        _vm._v(" Ajouter des couverts ?\n\t\t\t\t\t"),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "flex-start-center mb-20" }, [
      _c("i", { staticClass: "fsize-26 mob-fsize-22 fie-icon_offer mr-10" }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "color-grey1 text-uppercase text-bold fsize-16 mob-fsize-14",
        },
        [_vm._v("Utiliser votre carte fidélité ?\n\t\t\t\t\t")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }